import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import darkModeReducer from "./slices/darkModeSlice";
import languageReducer from "./slices/languageSlice";
import currencyReducer from "./slices/currencySlice";
import authReducer from "./slices/authSlice";
import adminReducer from "./slices/adminSlice";
import cartReducer from "./slices/cartSlice";
import sidebarReducer from "./slices/sidebarSlice";
import sidebarFilterReducer from "./slices/sidebarFilterSlice";
import tradeGroupSlicer from "./slices/tradeGroupsSlice";
import appReducer from "./slices/appSlice";
import settingsDrawerReducer from './slices/settingsDrawerSlice';
import systemMessageReducer from './slices/systemMessageSlice';
import { i18nMiddleware } from "../configuration/i18n/i18nMiddleware";

const store = configureStore({
  reducer: {
    darkMode: darkModeReducer,
    language: languageReducer,
    currency: currencyReducer,
    auth: authReducer,
    admin: adminReducer,
    cart: cartReducer,
    sidebar: sidebarReducer,
    sidebarFilter: sidebarFilterReducer,
    tradeGroup: tradeGroupSlicer,
    settingsDrawer: settingsDrawerReducer,
    systemMessage: systemMessageReducer,
    app: appReducer,
  },
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(i18nMiddleware),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Custom hook to provide correct dispatch types for async actions
export const useAppDispatch = () => useDispatch<AppDispatch>();